module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('material-table', {
    attrs: {
      "title": _vm.table1.title,
      "sub-title": _vm.table1.subTitle,
      "data": _vm.table1.data,
      "columns": _vm.table1.columns
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('material-table', {
    attrs: {
      "type": "plain",
      "title": _vm.table2.title,
      "sub-title": _vm.table2.subTitle,
      "data": _vm.table2.data,
      "columns": _vm.table2.columns
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74b5ad7e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/TableList.vue
// module id = 170
// module chunks = 2